import { onDomReady } from '../utils/dom';

/**
 * Bild-Slider (content_element/gallery/swiper): Jedes Bild wird proportional in der
 * 3:2-Box gezeigt (object-fit: contain, s. components/_gallery.scss). Damit Hochkant-
 * bzw. abweichende Formate keine leeren Balken haben, legt dieses Modul hinter jedes
 * Bild eine füllende, unscharfe Kopie desselben Bildes.
 *
 * Die Kopie ist ein Klon des kompletten <picture> (inkl. <source srcset sizes>), damit der
 * Browser für Blur und scharfes Bild denselben srcset-Kandidaten wählt und die Datei nur
 * einmal lädt. Ein eigenes <img src="…"> mit img.src wäre immer der JPG-Fallback in
 * voller Breite (bei loading="lazy" ist currentSrc zum DOM-Ready-Zeitpunkt noch leer) —
 * also eine zweite, deutlich größere Datei ohne AVIF (02.09.2026).
 *
 * Markup danach:
 *   <a|figure>
 *     <span class="gallery-media">
 *       <span class="gallery-media__blur" aria-hidden="true"><picture>…<img alt=""></picture></span>
 *       <picture>…</picture>
 *     </span>
 *   </a|figure>
 */
function addGalleryBlurBackgrounds() {
    document.querySelectorAll('.content-gallery--swiper .image_container').forEach((figure) => {
        const media = figure.querySelector('picture') || figure.querySelector('img');

        if (!media || media.closest('.gallery-media')) {
            return;
        }

        const img = media.tagName === 'IMG' ? media : media.querySelector('img');

        if (!img) {
            return;
        }

        const wrapper = document.createElement('span');
        wrapper.className = 'gallery-media';

        const blur = document.createElement('span');
        blur.className = 'gallery-media__blur';
        blur.setAttribute('aria-hidden', 'true');

        const copy = media.cloneNode(true);
        const copyImg = copy.tagName === 'IMG' ? copy : copy.querySelector('img');

        copyImg.alt = '';
        copyImg.removeAttribute('id');
        copyImg.removeAttribute('title');
        copyImg.removeAttribute('fetchpriority');
        copyImg.loading = 'lazy';
        copyImg.decoding = 'async';

        blur.appendChild(copy);
        media.parentNode.insertBefore(wrapper, media);
        wrapper.appendChild(blur);
        wrapper.appendChild(media);
    });
}

onDomReady(() => {
    addGalleryBlurBackgrounds();
});
